import Long from 'long';
import {action, computed, makeObservable, observable} from 'mobx';

import {IMCAttachment, IMCPeer, IMCPeerPreview, IMeta} from '../../api/proto';
import {formatUserName} from '../../utils/format';
import Chat from '../Chat';
import IPeerMetaInfo from './utils/IPeerMetaInfo';
import parseMetaInfo from './utils/parseMetaInfo';
import parsePeerMeta from './utils/parsePeerMeta';
import {TELEGRAM_PUBLIC_CHAT_LINK} from '../../config';

export class Peer implements IMCPeer {
  constructor(public raw: IMCPeerPreview, public chat?: Chat, public preview?: boolean) {
    makeObservable(this);
    this.fill(raw);
  }

  @observable id: Long = Long.ZERO;
  @observable channelID?: Uint8Array | null;
  @observable name?: string | null;
  @observable avatar?: IMCAttachment | null;
  @observable username?: string | null;
  @observable externalID?: Uint8Array | null;
  @observable meta?: IMeta | null;

  @computed get fullName(): string {
    if (this.metaInfo?.firstName || this.metaInfo?.lastName) {
      return formatUserName(this.metaInfo?.firstName, this.metaInfo?.lastName);
    }

    return this.name || '';
  }

  @computed get displayName(): string {
    return (
      this.fullName ||
      // this.chat?.title ||
      this.id?.toString() ||
      ''
    );
  }

  @action fill = (props?: IMCPeerPreview) => {
    Object.assign(this, props);
  };

  @computed get isOnline(): boolean {
    return false;
  }

  @computed get phoneNumber(): string {
    return this.metaInfo?.phoneNumber || '';
  }

  @computed get email(): string {
    return this.metaInfo?.email || '';
  }

  @computed get statusTitle(): string {
    return '';
  }

  @computed get metaInfo(): IPeerMetaInfo | null | undefined {
    return parsePeerMeta(this.meta);
  }

  @computed get metaData(): string[] {
    return parseMetaInfo(this.metaInfo?.metadata) || [];
  }

  @computed get link() {
    return this.username ? `${TELEGRAM_PUBLIC_CHAT_LINK}${this.username}` : null;
  }
}

export default Peer;
